import { render, staticRenderFns } from "./ingrediant.vue?vue&type=template&id=60115922&scoped=true&"
import script from "./ingrediant.vue?vue&type=script&lang=js&"
export * from "./ingrediant.vue?vue&type=script&lang=js&"
import style0 from "./ingrediant.vue?vue&type=style&index=0&id=60115922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60115922",
  null
  
)

export default component.exports